import { ApiStudentRequest, request } from '../utils/request'
import { useQuery } from '@tanstack/react-query'

export type RawSpaConfigResponse = {
  auth: {
    issuer: string
    clientId: string
    redirectUri: string
  }
  monitorConfig?: {
    config: {
      guestRoleArn: string
      identityPoolId: string
    }
    appMonitorId: string
    region: string
  }
}

type SpaConfig = {
  isLoading: boolean
  config: {
    issuer: string
    clientId: string
    redirectUri: string
  } | null
  monitorConfig?: {
    config: {
      guestRoleArn: string
      identityPoolId: string
    }
    appMonitorId: string
    region: string
  }
}

export function useGetSpaConfig(): SpaConfig {
  const { isLoading, data } = useQuery({
    queryKey: ['spaConfig'],
    queryFn: async () => {
      const response = await request<RawSpaConfigResponse>(
        new ApiStudentRequest(`/spa-config`, { method: 'GET' }),
        {
          isExpectedResponse: (res): res is RawSpaConfigResponse => res,
        },
      )
      return response
    },
    enabled: true,
    refetchOnWindowFocus: false,
    retry: false,
  })

  return {
    isLoading: isLoading,
    config: data?.auth ?? null,
    monitorConfig: data?.monitorConfig ?? undefined,
  }
}
